import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Row, Col, Card } from "antd";

import { setFilters } from "../branchTransferReceiveSlice";
import {
  fetchBranchTransferReceiveList,
  fetchBranches,
} from "../branchTransferReceiveThunk";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import { SearchOutlined } from "@ant-design/icons";
import { useLocation, useSearchParams } from "react-router-dom";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";

const BranchTransferReceiveFilters = () => {
  const dispatch = useDispatch();
  const { filters, branches } = useSelector(
    (state) => state.branchTransferReceive
  );
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  useDefaultDateRange(setFilters, filters, "today");

  useEffect(() => {
    dispatch(fetchBranches());
  }, [dispatch]);
  const handleSubmit = () => {
    dispatch(fetchBranchTransferReceiveList({ filters }));
  };

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  // handleFilterChange only queues the update, so running the report right here
  // would still use the old (default) filters — flag it and run it from the
  // next effect, once the drill-down filters have been applied.
  const [drillReady, setDrillReady] = useState(false);
  useEffect(() => {
    const path = pathname.split("/")[3];
    if (path) {
      const fromDate = searchParams.get("fromDate");
      if (fromDate) {
        handleFilterChange("fromDate", fromDate);
      }
      handleFilterChange("toDate", path);
      setDrillReady(true);
    }
  }, []);
  useEffect(() => {
    if (drillReady) handleSubmit();
  }, [drillReady]);
  
  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={16} style={{ alignItems: "center" }}>
        {/* Filter Type */}
        <Col xs={24} sm={12} md={8} lg={6} xl={4}>
          <label>Filter Type</label>
          <SearchListAutoComplete
            optionsList={[{ sale_id: "All", display_text: "All" }]}
            value={
              filters.filterType
                ? { value: filters.filterType, label: filters.filterType }
                : undefined
            }
            onSelect={(obj) => {
              if(!obj) {
                handleFilterChange("filterType", null);
                return;
              } 
              handleFilterChange("filterType", obj?.sale_id);
            }}
            placeholder="Filter Type"
            showAddNew={false}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={6} xl={4}>
          <label>By Branch</label>
          <SearchListAutoComplete
            entityType="branch"
            optionsList={(branches || []).map((e) => ({
              sale_id: e.id,
              display_text: e.name,
            }))}
            onSelect={(obj) => {
              if(!obj) {
                handleFilterChange("fromBranchId", null);
                return;
              } 
              handleFilterChange("fromBranchId", obj?.sale_id);
            }}
            placeholder="By Branch"
            showAddNew={false}
          />
        </Col>
        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
          handleFilterChange("fromDate", fromDate);
          handleFilterChange("toDate", toDate);
          }}
        />
        <Col
          xs={24}
          sm={12}
          md={8}
          lg={6}
          xl={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSubmit}
            block
            style={{height: 35.19}}
            data-testid="report-btn"
          >
            Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default BranchTransferReceiveFilters;
